import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import {
	readClarityWorkspaceRoute,
	toClaritySectionUrl,
	toNavigationUnlessCurrent,
} from './clarity-workspace-route.util';
import type { ClarityWorkspaceNavigation } from './models/clarity-workspace-navigation.model';
import { parseClarityWorkspaceLocation } from './parse-clarity-workspace-location.util';

/** Ported from Clarity `apps/web/src/shared/hooks/useWorkspaceRoute.ts` (commit `63bab2253`). */
/**
 * Closing the open document — brain's `closeDocument()`: a **push** that **keeps the current tab** and
 * drops `doc`, `page`, `file`, `oi` and `action`, carries every other query key verbatim, and is `null` —
 * no navigation — when that URL is `currentUrl` (their TR-014).
 *
 * Keeping the tab is the point: the System Domain stays where it is, and the Documents tab stays on
 * `documents` rather than being bounced to the default.
 *
 * Only the integration is adapted: the current URL is an argument read at call time, the answer sits
 * under `sectionPath`, and the navigation is handed back rather than performed.
 */
export function toClarityCloseDocumentNavigation(
	currentUrl: string,
	sectionPath: string,
): ClarityWorkspaceNavigation | null {
	const current = readClarityWorkspaceRoute(currentUrl, sectionPath);
	const { domainId, tab } = parseClarityWorkspaceLocation(current.params, current.search);
	const url = buildClarityWorkspaceUrl(
		{ domainId, tab, doc: null, page: null, file: null, oi: null, action: null },
		current.search,
	);

	return toNavigationUnlessCurrent(current, toClaritySectionUrl(sectionPath, url), false);
}
